define(["./numberModule"], function (numberModule) {
    "use strict";

    return numberModule.filter("percentage", [ "$filter", function ($filter) {
        return function (number, decimals) {
            return $filter("number")(number, decimals) + "%";
        };
    }]);
});